export type SkillCategory =
  | 'All'
  | 'Built-in'
  | 'Channels'
  | 'Productivity'
  | 'Chat'
  | 'Tools & Automation'
  | 'Social'
  | 'Platform'
  | 'Other';

export const SKILL_CATEGORY_ORDER: SkillCategory[] = [
  'All',
  'Built-in',
  'Channels',
  'Chat',
  'Productivity',
  'Tools & Automation',
  'Social',
  'Platform',
  'Other',
];
